import MainRoutes from "./Routes.js";
import "react-medium-image-zoom/dist/styles.css";

function App() {
    return <MainRoutes />;
}

export default App;
